/* eslint-disable react/prefer-es6-class, react/prefer-stateless-function */
import React from 'react';
import { t } from 'es6/services/localization';
import * as Paths from 'es6/core/paths';

export default React.createClass({
  displayName: 'PremiumLink',

  propTypes: {
    source: React.PropTypes.string.isRequired,
  },

  render() {
    return (
      <a href={Paths.payment(this.props.source)} className="premium-button">{t('sign up to become a premium member!')}</a>
    );
  },
});
